import { AfterContentInit, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { COMMON_MODULES } from '@src/app/core/constants/common-module.constant';
import { MiniEnvContentBoxComponent } from '../mini-env-content-box/mini-env-content-box.component';

@Component({
  selector: 'app-mini-env-tabs',
  imports: [...COMMON_MODULES, MiniEnvContentBoxComponent],
  templateUrl: './mini-env-tabs.component.html',
  styleUrl: './mini-env-tabs.component.scss'
})
export class MiniEnvTabsComponent extends CoreClass implements OnInit, AfterContentInit {

  @Input() serviceNames : any[] = [];

  panes: any[] = [];

  @Input() imgSrc: string = '';
  @Input() imgSrcMob: string = '';
  @Output() buttonAction: EventEmitter<void> = new EventEmitter<void>();

  // Below this width the tabs render as an accordion where multiple panes
  // can be open at once; above it they behave as single-select tabs.
  isMobile = false;

  ngOnInit(): void {
    this.isMobile = this.checkIsMobile();
    this.getServicesForTabs();
  }

  private checkIsMobile(): boolean {
    return typeof window !== 'undefined' && window.innerWidth <= 768;
  }

  @HostListener('window:resize')
  onResize(): void {
    const wasMobile = this.isMobile;
    this.isMobile = this.checkIsMobile();
    // Leaving the accordion for the single-select tab layout: keep only one pane open.
    if (wasMobile && !this.isMobile) {
      const firstActive = this.panes.findIndex(p => p.active);
      const activeIndex = firstActive === -1 ? 0 : firstActive;
      this.panes.forEach((pane, i) => (pane.active = i === activeIndex));
    }
  }

  async getServicesForTabs() {
    try {
      const services = await this.sharedService.getServicesForTabs(); 
      console.log(services);
      
      
      this.serviceNames.forEach((service: string, index: number) => {
        const serviceDetails = services.find((s: any) => s.serviceCode === service);
        if (serviceDetails) {
          this.panes.push({...serviceDetails, active: index === 0});
        }
        console.log(this.panes);
        
      });
    } catch (error) {
      console.error('Error fetching services for tabs:', error);
    }
  }

   ngAfterContentInit(): void {
    const panesArray = this.panes;

    // Ensure one tab is active
    const activePane = panesArray.find(p => p.active);
    if (!activePane && panesArray.length) {
      panesArray[0].active = true;
    }
  }

  select(index: number): void {
    if (this.isMobile) {
      // Accordion: toggle this pane independently so multiple can stay open.
      this.panes[index].active = !this.panes[index].active;
      return;
    }
    // Tabs: single selection.
    this.panes.forEach((pane, i) => {
      pane.active = i === index;
    });
  }

  onButtonAction(action: any): void {
    this.buttonAction.emit(action);
  }
}
